jQuery(document).ready(function($) {
    const $menu = $('#sidenav');
    const $background = $('#sidenav-background');
    const $boxshadow = $('#sidenav-boxshadow');

    // Controla la visibilidad del menú
    function toggleMenu() {
        $menu.toggleClass('visible');
        $background.toggleClass('visible');
        $boxshadow.toggleClass('visible');
    }

    // Establece los controladores de eventos para abrir y cerrar el menú
    $('#open-menu, #close-menu').on('click', toggleMenu);
    
    // Cierra el menú también al hacer click en 'Contacto'
    $('#main-menu li:last-child()').on('click', function() {
        if($menu.hasClass('visible')) {
            toggleMenu();
        }
    })

    // Controla la visibilidad de los submenús
    $('.menu-item-has-children').on('click', function(event) {
        if ($menu.hasClass('visible')) {
            const $target = $(event.target);

            $('.sub-menu').each(function() {
                let $submenu = $(this);
                let height = 0;

                if ($menu.has($target).length && $submenu.is($target.closest('.menu-item').find('.sub-menu'))) {
                    height = $submenu.height() === 0 ? $submenu.prop('scrollHeight') + 25 : 0;
                }

                $submenu.css('height', height + 'px');
                $submenu.closest('.menu-item').toggleClass('arrow', height !== 0);
            });

            if (!$menu.has($target).length) {
                toggleMenu();
            }
        }
    });
});
